import { LOGIQUE_SECTIONS } from"@/data/logique";
import { CLASSES } from"@/data/classMeta";

export default function Logique({ onSelectClass }) {
 return (
 <div data-testid="logique-view" className="space-y-8">
 <div>
 <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full border border-[#3B1E6E]/30 bg-purple-50 text-[#3B1E6E] mb-3">
 Module pédagogique
 </span>
 <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-[#15294F] tracking-tight">
 La logique des classes du PCG
 </h2>
 <p className="text-slate-600 mt-3 text-base max-w-2xl">
 Comprendre la <em>numérotation</em>, c'est apprendre à imputer correctement sans
 chercher dans une liste. Voici les principes structurants du PCG 2025.
 </p>
 </div>

 <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
 {CLASSES.map((cls) => (
 <button
 key={cls.id}
 data-testid={`logique-class-${cls.id}`}
 onClick={() => onSelectClass(cls.id)}
 className="text-left p-5 rounded-xl border border-keyto bg-white shadow-keyto-sm hover:shadow-keyto transition-all"
 style={{ borderTop: `3px solid ${cls.color.primary}` }}
 >
 <div
 className="font-mono font-black text-4xl mb-1"
 style={{ color: cls.color.text }}
 >
 {cls.id}
 </div>
 <div className="font-heading font-extrabold text-base text-[#15294F] leading-tight">
 {cls.label}
 </div>
 <div className="text-xs text-slate-500 mt-2">{cls.nature}</div>
 </button>
 ))}
 </div>

 <div className="space-y-4">
 {LOGIQUE_SECTIONS.map((s, i) => (
 <div
 key={i}
 data-testid={`logique-section-${i}`}
 className="bg-white border border-keyto rounded-xl shadow-keyto-sm p-6"
 >
 <div className="flex items-center gap-3 mb-3">
 <span className="font-mono font-extrabold text-2xl text-[#2D6BE0]">
 {String(i + 1).padStart(2,"0")}
 </span>
 <h3 className="font-heading text-lg font-extrabold text-[#15294F]">
 {s.titre}
 </h3>
 </div>
 <p className="text-base text-slate-700 leading-relaxed">{s.contenu}</p>
 </div>
 ))}
 </div>

 <div className="bg-[#15294F] text-white rounded-2xl shadow-keyto-lg p-6 md:p-8">
 <h3 className="font-heading text-xl font-extrabold mb-3">
 Mémo express : la partie double
 </h3>
 <div className="grid sm:grid-cols-2 gap-6 text-sm">
 <div>
 <p className="font-bold text-emerald-300 mb-2">Au débit (D)</p>
 <ul className="space-y-1 text-slate-200">
 <li>• Augmentation d'un actif (banque, stock, immo, créance)</li>
 <li>• Diminution d'un passif (dette payée)</li>
 <li>• Constatation d'une charge</li>
 </ul>
 </div>
 <div>
 <p className="font-bold text-rose-300 mb-2">Au crédit (C)</p>
 <ul className="space-y-1 text-slate-200">
 <li>• Diminution d'un actif (paiement, sortie de stock)</li>
 <li>• Augmentation d'un passif (dette contractée)</li>
 <li>• Constatation d'un produit</li>
 </ul>
 </div>
 </div>
 </div>
 </div>
 );
}
